import { Link } from "react-router-dom";
import { Select } from "antd";

import CollapseHeader from "../../../../../core/common/collapse-header/collapse-header";

import type { CompanyOption } from "../../types/automation.types";

interface AutomationListHeaderProps {
  title: string;
  breadcrumb: string;
  workflowCategory: string;
  dashboardRoute: string;
  createRoute: string;
  companies: CompanyOption[];
  activeCompanyKey: string | null;
  companiesLoading: boolean;
  onCompanyChange: (company: CompanyOption) => void;
}

const filterOption = (input: string, option?: { label: string; value: any }) =>
  (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase());

const AutomationListHeader: React.FC<AutomationListHeaderProps> = ({
  title,
  breadcrumb,
  workflowCategory,
  dashboardRoute,
  createRoute,
  companies,
  activeCompanyKey,
  companiesLoading,
  onCompanyChange,
}) => {
  const handleSelect = (value: string) => {
    const match = companies.find((c) => c.value === value);
    if (match) onCompanyChange(match);
  };

  return (
    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <div className="my-auto mb-2">
        <h2 className="mb-1">{title}</h2>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={dashboardRoute}>
                <i className="ti ti-smart-home" />
              </Link>
            </li>
            <li className="breadcrumb-item">Automations</li>
            <li className="breadcrumb-item active" aria-current="page">
              {breadcrumb}
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex align-items-center ms-auto flex-wrap gap-2 mb-2">
        <Select
          showSearch
          filterOption={filterOption}
          style={{ width: 260, minHeight: 38 }}
          placeholder={companiesLoading ? "Loading companies..." : "Select Company"}
          value={activeCompanyKey || undefined}
          loading={companiesLoading}
          disabled={companiesLoading}
          onChange={handleSelect}
          options={companies.map((c) => ({ value: c.value, label: c.label }))}
        />
        <Link
          to={createRoute}
          state={{ workflowCategory }}
          className="btn btn-primary d-inline-flex align-items-center"
          style={{ minHeight: 38 }}
        >
          <i className="ti ti-circle-plus me-1" />
          New Automation
        </Link>
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div className="head-icons mb-0">
            <CollapseHeader />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutomationListHeader;
